export const iconFontAwesomeArrowsCircleDown = (
	<i className="fa-solid fa-circle-down"></i>
);
